import React from 'react';

const MembershipCta = () => {
    return (
        <>
            <hr className="w-100 my-4" />
            <div className="text-center">
                <p className="display8 bold mb-2">Not a Member?</p>
                <a href="/join/become-a-member" className="display8 accent">
                    Become a Member Today
                </a>
            </div>
        </>
    );
};

MembershipCta.propTypes = {};

export default MembershipCta;
